













































import { Component, Prop, Vue } from "@/shared/vuepack";
import {
  HsabExpenseReimbursementResponse,
  HsabSsoDestination,
  HsabExpenseResponse,
  UnusedDistributionResponse, ExpenseSubmitLogItem,
  HsabExpenseFormType, HsabExpenseEvidenceResponse,
} from "@/shared/types";
import AccountHolderExpenseDetail from "@/employer/components/partner-ee-service/AccountHolderExpenseDetail.vue";
import AccountHolderExpenseEvidence from "@/employer/components/partner-ee-service/AccountHolderExpenseEvidence.vue";
import AccountHolderExpenseSubmission from "@/employer/components/partner-ee-service/AccountHolderExpenseSubmission.vue";
import AccountHolderExpensePayee from "@/employer/components/partner-ee-service/AccountHolderExpensePayee.vue";
import AccountHolderExpenseDenial from "@/employer/components/partner-ee-service/AccountHolderExpenseDenial.vue";
import AccountHolderExpenseDistributionDetail from "@/employer/components/partner-ee-service/AccountHolderExpenseDistributionDetail.vue";
import AccountHolderExpenseRepayments from "@/employer/components/partner-ee-service/AccountHolderExpenseRepayments.vue";
import AccountHolderExpenseReimbursement from "@/employer/components/partner-ee-service/AccountHolderExpenseReimbursement.vue";
import AccountHolderExpenseInformationRequest from "@/employer/components/partner-ee-service/AccountHolderExpenseInformationRequest.vue";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";

@Component({
  computed: {
    HsabSsoDestination () {
      return HsabSsoDestination;
    }
  },
  components: {
    AccountHolderExpenseReimbursement,
    AccountHolderExpenseRepayments,
    AccountHolderExpenseDenial,
    AccountHolderExpensePayee,
    AccountHolderExpenseDetail,
    AccountHolderExpenseEvidence,
    AccountHolderExpenseSubmission,
    AccountHolderExpenseDistributionDetail,
    AccountHolderExpenseInformationRequest,
  }
})
export default class AccountHolderExpenseModal extends Vue {
  HsabExpenseFormType = HsabExpenseFormType;
  hsabExpenseStore = useHsabExpenseStore();
  isAddingAdditionalEvidence = false;
  isUploadingFilesToSubmittedExpense = false;
  showRepayClaimModal = false;
  loaded = false;
  expenseSubmitLogItems: ExpenseSubmitLogItem[] = [];
  stagedFilesForUpload = [];

  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;

  @Prop()
  hsabExpenseFormType: HsabExpenseFormType;

  @Prop()
  expense: HsabExpenseResponse;

  @Prop()
  unusedDistribution: UnusedDistributionResponse;

  get hasOverflowReimbursements () {
    return this.hasReimbursement
      && this.reimbursement.overflowReimbursements
      && this.reimbursement.overflowReimbursements.length > 0;
  }

  get hasReimbursement (): boolean {
    return this.expense !== null && this.expense.reimbursement !== null;
  }
  get reimbursement (): HsabExpenseReimbursementResponse {
    return this.hasReimbursement ? this.expense.reimbursement : null;
  }
  get expenseEvidence (): HsabExpenseEvidenceResponse[] {
    return this.hasExpenseEvidence ? this.expense.expenseEvidence : null;
  }
  get hasExpenseEvidence (): boolean {
    return this.expense !== null && this.expense.expenseEvidence !== null
        && this.expense.expenseEvidence.length > 0;

  }
  get showDenialReasons (): boolean {
    if (this.hasOverflowReimbursements) {
      return false;
    }
    const hasReimbursement = this.expense && this.expense.reimbursement;
    const hasDenialReasons = hasReimbursement
        && this.expense.reimbursement.denialReasons
        && this.expense.reimbursement.denialReasons.length > 0;
    const hasDeniedAmount = hasReimbursement && this.expense.reimbursement.deniedAmount > 0;

    return hasReimbursement && (hasDenialReasons || hasDeniedAmount);
  }
  get showInformationRequests (): boolean {
    return this.expense
        && this.expense.reimbursement
        && this.expense.reimbursement.informationRequests
        && this.expense.reimbursement.informationRequests.length > 0;
  }
  get showRepayments (): boolean {
    return this.expense
        && this.expense.reimbursement
        && this.expense.reimbursement.repayments
        && this.expense.reimbursement.repayments.length > 0;
  }
  get hasExpenseSubmitLogItems (): boolean {
    return this.expenseSubmitLogItems !== null && this.expenseSubmitLogItems.length > 0;
  }
  mounted () {
    this.loadData();
  }
  async loadData () {
    if (!this.loaded) {
      const args = { username: this.username, partnerId: this.partnerId };
      this.expenseSubmitLogItems = await this.hsabExpenseStore.getSubmitLogsById(this.expense.hsabExpenseId, args);
      this.loaded = true;
    }
  }
}
